/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_New_GroupInputs */

const cs_chat_new_group = /** @type {(inputs: Chat_New_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skupinový chat`)
};

const en_chat_new_group = /** @type {(inputs: Chat_New_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group chat`)
};

/**
* | output |
* | --- |
* | "Group chat" |
*
* @param {Chat_New_GroupInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_new_group = /** @type {((inputs?: Chat_New_GroupInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_New_GroupInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_new_group(inputs)
	return cs_chat_new_group(inputs)
});